import { render, staticRenderFns } from "./delivery_detail.vue?vue&type=template&id=8256c2b6&scoped=true"
import script from "./delivery_detail.vue?vue&type=script&lang=js"
export * from "./delivery_detail.vue?vue&type=script&lang=js"
import style0 from "./delivery_detail.vue?vue&type=style&index=0&id=8256c2b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8256c2b6",
  null
  
)

export default component.exports